
import UploadCardsView from './Views/UploadCardsView';
import LogInView from './Views/LogInView';
import HomeView from './Views/HomeView';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';


import './App.css';

function App() {
  return (
    <Router>
      <Switch>
      <Route exact path="/" component={HomeView} />
      <Route exact path="/login" component={LogInView} />
      <Route exact path="/upload" component={UploadCardsView} />


      </Switch>
    </Router>
  )
}
export default App;
